import { render, staticRenderFns } from "./Renovavel.vue?vue&type=template&id=64de7aff&"
import script from "./Renovavel.vue?vue&type=script&lang=js&"
export * from "./Renovavel.vue?vue&type=script&lang=js&"
import style0 from "./Renovavel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports